import { render } from "./maintainHistory.vue?vue&type=template&id=b8c56acc&scoped=true"
import script from "./maintainHistory.vue?vue&type=script&lang=js"
export * from "./maintainHistory.vue?vue&type=script&lang=js"

import "./maintainHistory.vue?vue&type=style&index=0&id=b8c56acc&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c56acc"]])

export default __exports__